export default __webpack_public_path__ + "static/media/540.a6b13aa4.png";